import { FinancialOverviewRowDTO } from '../types/FinancialDTO';

const MONTHS = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export const formatCurrency = (value?: number | null) => {
	return value === undefined || value === null ? '' : currency.format(value);
};

export const monthLabel = (month: string) => {
	const [year, index] = month.split('-');
	return `${MONTHS[Number(index) - 1]}/${year}`;
};

export const formatDate = (date?: string | null) => {
	if (!date) {
		return '';
	}
	const [year, month, day] = date.substring(0, 10).split('-');
	return `${day}/${month}/${year}`;
};

export const statusColor = (status?: string) => {
	if (status === 'PAID') {
		return 'rgba(76, 175, 80, 0.22)';
	}
	if (status === 'OVERDUE') {
		return 'rgba(244, 67, 54, 0.22)';
	}
	return 'rgba(255, 193, 7, 0.22)';
};

export const matchesStatusFilter = (row: FinancialOverviewRowDTO, months: string[], filter: string) => {
	if (filter === 'ALL') {
		return true;
	}
	if (filter === 'CURRENT_OVERDUE') {
		const current = [...months].sort().pop();
		return !!current && (row.bills[current] || []).some(bill => bill.status === 'OVERDUE');
	}
	if (filter === 'OPEN') {
		return months.some(month => (row.bills[month] || []).some(bill => bill.status !== 'PAID'));
	}
	return months.some(month => (row.bills[month] || []).some(bill => bill.status === filter));
};

const monthTotal = (row: FinancialOverviewRowDTO, month: string) => {
	const bills = row.bills[month] || [];
	return bills.length ? bills.reduce((total, bill) => total + (bill.value || 0), 0) : null;
};

export const compareOverviewRows = (a: FinancialOverviewRowDTO, b: FinancialOverviewRowDTO, key: string, ascending: boolean) => {
	const direction = ascending ? 1 : -1;
	if (key === 'NAME') {
		return direction * (a.companyName || '').localeCompare(b.companyName || '');
	}
	const first = monthTotal(a, key);
	const second = monthTotal(b, key);
	if (first === null || second === null) {
		return first === second ? (a.companyName || '').localeCompare(b.companyName || '') : first === null ? 1 : -1;
	}
	return direction * (first - second) || (a.companyName || '').localeCompare(b.companyName || '');
};

export const downloadBlob = (blob: Blob, fileName: string) => {
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = fileName;
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.URL.revokeObjectURL(url);
};
